import { FC, useEffect } from 'react';
import { AccountsInfo } from '../AccountsViewDrawer/AccountsViewDrawer';
import { ActionStatuses, MarginTypes } from '@shared/api';
import moment from 'moment-timezone';
import { useSteps } from '@features/Steps';
import { booleanOptions, marginTypesOptions, statusOptions } from '../utils/consts';
import { IAccountDrawerStep } from '../AccountsViewDrawer/interfaces';
import { formats } from '@shared/utils';

export const GeneralStep: FC<IAccountDrawerStep> = ({ account, setEditedValues, editedValues, fromDetail }) => {
    const { pushAllowedStep } = useSteps();

    useEffect(() => {
        pushAllowedStep(0);
        pushAllowedStep(1);
        pushAllowedStep(2);
        pushAllowedStep(3);
    }, [pushAllowedStep]);

    const onChange = (key: string, value: string | boolean | number) => {
        setEditedValues({ ...editedValues, [key]: value });
    };

    return (
        <div className='widget-trade-status-table-drawer__content'>
            <AccountsInfo
                value={String(account?.id)}
                fieldName='ID'
            />
            <AccountsInfo
                value={editedValues.enabled.toString()}
                fieldName='Enabled'
                editableField={fromDetail ? undefined : 'select'}
                options={booleanOptions}
                onChange={onChange}
                keyName='enabled'
            />
            <AccountsInfo
                value={String(editedValues.cash)}
                fieldName='Cash'
                editableField={fromDetail ? undefined : 'input'}
                onChange={onChange}
                keyName='cash'
            />
            <AccountsInfo
                value={String(editedValues.baseCash)}
                fieldName='Base Cash'
                editableField={fromDetail ? undefined : 'input'}
                onChange={onChange}
                keyName='baseCash'
            />
            <AccountsInfo
                value={account?.currency}
                fieldName='Currency'
            />
            <AccountsInfo
                value={account?.clearingAccount}
                fieldName='Account Number'
            />
            <AccountsInfo
                value={String(moment(account?.createdDate).format(formats.fullTime))}
                fieldName='Created Date'
            />
            <AccountsInfo
                value={String(moment(account?.modifiedDate).format(formats.fullTime))}
                fieldName='Modified Date'
            />
            <AccountsInfo
                value={String(ActionStatuses[editedValues.status as number])}
                fieldName='Status'
                editableField={fromDetail ? undefined : 'select'}
                onChange={onChange}
                options={statusOptions}
                keyName='status'
            />
            <AccountsInfo
                value={String(MarginTypes[editedValues.marginType as number])}
                fieldName='Margin Type'
                editableField={fromDetail ? undefined : 'select'}
                options={marginTypesOptions}
                keyName='marginType'
                onChange={onChange}
            />
            <AccountsInfo
                className='noBorder'
                value={editedValues.isAverageAccount.toString()}
                fieldName='Is Average Account'
                editableField={fromDetail ? undefined : 'select'}
                keyName='isAverageAccount'
                onChange={onChange}
                options={booleanOptions}
            />
            <AccountsInfo
                className='noBorder'
                value={editedValues.isError.toString()}
                fieldName='Error'
                editableField='select'
                keyName='isError'
                onChange={onChange}
                options={booleanOptions}
            />
            <AccountsInfo
                className='noBorder'
                value={editedValues.isInventory.toString()}
                fieldName='Inventory'
                editableField='select'
                keyName='isInventory'
                onChange={onChange}
                options={booleanOptions}
            />
            <AccountsInfo
                className='noBorder'
                value={String(account?.fdid)}
                fieldName='FDID'
            />
            <AccountsInfo
                value={String(account?.customerType)}
                fieldName='Customer Type'
                keyName='customerType'
            />
        </div>
    );
};
